(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var hdr = document.getElementById('hdr');

  /* -- Locked viewport height --
     Some mobile browsers (DuckDuckGo notably) don't honour svh, so their address
     bar still reflows 100vh on scroll-up. Lock the hero height to a real pixel
     value measured at load and only on rotation. Never on scroll or resize, since
     resize fires DURING the toolbar animation and re-measuring there is the jitter
     itself. CSS uses this var ahead of its svh/vh fallbacks. */
  function setAppHeight(){
    document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
  }
  setAppHeight();
  window.addEventListener('orientationchange', function(){ setTimeout(setAppHeight, 250); });

  /* -- Focus utilities -- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusables(container){
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE))
      .filter(function(el){ return el.offsetParent !== null || el === document.activeElement; });
  }
  function trapFocus(e, container){
    if(e.key !== 'Tab') return;
    var f = focusables(container);
    if(!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }

  /* -- Background inert while a modal is open --
     The dialogs were already inert when closed; the gap (flagged in audit) was that
     the REST of the page stayed reachable to screen-reader virtual navigation while a
     dialog was OPEN. Toggle inert on background regions on open/close.
     Sheet has its own close button + backdrop, so the whole chrome (header+main+footer)
     can go inert. The nav overlay's only close control is the header hamburger (it
     morphs to an X), so the header stays interactive and only main+footer are inerted. */
  var mainEl = document.getElementById('main-content');
  var footerEl = document.querySelector('footer');
  function setInert(els, on){
    els.forEach(function(el){ if(!el) return; if(on){ el.setAttribute('inert',''); } else { el.removeAttribute('inert'); } });
  }

  /* -- Veil intro animation -- */
  /* Plays once per browser session only (sessionStorage), resolves quickly so a
     first-time visitor reaches the hero without waiting. Subsequent navigations
     within the session skip it entirely. */
  var cover = document.getElementById('veil-cover');
  var veilSeen;
  try { veilSeen = sessionStorage.getItem('vlm_veil_seen'); } catch(err){ veilSeen = null; }
  if(cover && veilSeen){
    cover.style.display='none';
  } else if(cover && !reduce){
    try { sessionStorage.setItem('vlm_veil_seen','1'); } catch(err){}
    window.addEventListener('load',function(){ setTimeout(function(){ cover.classList.add('lift'); },750); });
    setTimeout(function(){ cover.classList.add('lift'); },1400);
  } else if(cover){ cover.style.display='none'; }

  /* -- Sticky header (hysteresis: add at >80, remove only below 20). A single
     threshold flutters when scrollY wobbles across it, which is exactly what the
     mobile address bar does as it slides back in on scroll-up. The dead-band
     between 20 and 80 makes that wobble harmless. rAF-throttled, and the class is
     only written when the state actually changes. -- */
  if(hdr){
    var hdrScrolled = false, hdrTick = false;
    function updateHdr(){
      var y = window.scrollY;
      if(!hdrScrolled && y > 80){ hdrScrolled = true; hdr.classList.add('scrolled'); }
      else if(hdrScrolled && y < 20){ hdrScrolled = false; hdr.classList.remove('scrolled'); }
      hdrTick = false;
    }
    window.addEventListener('scroll',function(){
      if(!hdrTick){ requestAnimationFrame(updateHdr); hdrTick = true; }
    },{ passive:true });
    updateHdr();
  }

  /* -- Scroll-reveal (content already visible without JS via .no-js / .js gate in CSS) -- */
  if('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{
      /* threshold 0 + a bottom-margin trigger means even a tall element (like the
         full ingredient list) reveals as soon as its top nears the viewport,
         instead of waiting for 15% of its large height to scroll into view. */
      threshold: 0,
      rootMargin: '0px 0px -12% 0px'
    });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* -- FAQ accordion (accessible: the panel is removed from the accessibility tree
     when collapsed via the hidden attribute, kept in sync with aria-expanded; it
     animates by un-hiding, forcing reflow, transitioning, then re-hiding on
     transitionend so the closed panel is never exposed to assistive tech) -- */
  (function(){
    var qs = Array.prototype.slice.call(document.querySelectorAll('.q'));
    function ansOf(q){ return q.querySelector('.ans'); }
    function btnOf(q){ return q.querySelector('button'); }
    function closeQ(q){
      var b=btnOf(q), a=ansOf(q);
      if(b) b.setAttribute('aria-expanded','false');
      if(!q.classList.contains('open')){ if(a) a.hidden=true; return; }
      q.classList.remove('open');
      if(!a) return;
      if(reduce){ a.hidden=true; return; }
      var done=function(e){ if(e.target!==a || e.propertyName!=='max-height') return; a.hidden=true; a.removeEventListener('transitionend',done); };
      a.addEventListener('transitionend',done);
      setTimeout(function(){ if(!q.classList.contains('open')){ a.hidden=true; } },650);
    }
    function openQ(q){
      var b=btnOf(q), a=ansOf(q);
      if(a){ a.hidden=false; void a.offsetHeight; }
      q.classList.add('open');
      if(b) b.setAttribute('aria-expanded','true');
    }
    qs.forEach(function(q){
      var b=btnOf(q), a=ansOf(q);
      if(a) a.hidden=true;
      if(b){
        b.setAttribute('aria-expanded','false');
        b.addEventListener('click',function(){
          var willOpen=!q.classList.contains('open');
          qs.forEach(function(x){ if(x!==q) closeQ(x); });
          if(willOpen){ openQ(q); } else { closeQ(q); }
        });
      }
    });
  })();

  /* -- VLM-4 active cards --
     On desktop the card bodies are always shown via CSS and the toggle is
     non-interactive, so the buttons must report aria-expanded="true" and leave the
     tab order (they control nothing visible-state-wise). On mobile they are real
     disclosure buttons: aria-expanded tracks state and they stay keyboard-focusable.
     Re-applied on breakpoint change so a resize can't strand a misleading state. -- */
  (function(){
    var cards = Array.prototype.slice.call(document.querySelectorAll('.four .a'));
    if(!cards.length) return;
    var mq = window.matchMedia('(max-width:880px)');
    function applyMode(){
      var mobile = mq.matches;
      cards.forEach(function(card){
        var btn=card.querySelector('.a-toggle');
        if(!btn) return;
        if(mobile){
          btn.removeAttribute('tabindex');
          btn.setAttribute('aria-expanded', card.classList.contains('expanded') ? 'true' : 'false');
        } else {
          card.classList.remove('expanded');
          btn.setAttribute('aria-expanded','true');
          btn.setAttribute('tabindex','-1');
        }
      });
    }
    applyMode();
    if(mq.addEventListener){ mq.addEventListener('change', applyMode); }
    else if(mq.addListener){ mq.addListener(applyMode); }
    cards.forEach(function(card){
      var btn=card.querySelector('.a-toggle');
      if(!btn) return;
      btn.addEventListener('click',function(){
        if(!mq.matches) return; /* desktop: not an interactive control */
        var isOpen=card.classList.contains('expanded');
        cards.forEach(function(c){
          c.classList.remove('expanded');
          var t=c.querySelector('.a-toggle');
          if(t) t.setAttribute('aria-expanded','false');
        });
        if(!isOpen){ card.classList.add('expanded'); btn.setAttribute('aria-expanded','true'); }
      });
    });
  })();

  /* -- Mobile nav overlay (focus trap + restore + inert) -- */
  var mb      = document.getElementById('menuBtn');
  var overlay = document.getElementById('nav-overlay');
  var navOpener = null;
  function openNav(){
    navOpener = document.activeElement;
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden','false');
    overlay.removeAttribute('inert');
    mb.classList.add('open');
    mb.setAttribute('aria-expanded','true');
    hdr && hdr.classList.add('nav-open');
    setInert([hdr, mainEl, footerEl], true);
    document.body.style.overflow = 'hidden';
    overlay.scrollTop = 0;
    /* Focus the dialog container itself (tabindex -1), NOT the first link.
       Focusing a link inside an overflow container makes the browser scroll it
       into view, which yanks the overlay and causes the first item to jump. */
    setTimeout(function(){ overlay.focus(); }, 50);
  }
  function closeNav(){
    if(!overlay.classList.contains('open')) return;
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden','true');
    overlay.setAttribute('inert','');
    mb.classList.remove('open');
    mb.setAttribute('aria-expanded','false');
    hdr && hdr.classList.remove('nav-open');
    setInert([hdr, mainEl, footerEl], false);
    document.body.style.overflow = '';
    if(navOpener && navOpener.focus) navOpener.focus();
  }
  if(mb && overlay){
    mb.addEventListener('click',function(){
      overlay.classList.contains('open') ? closeNav() : openNav();
    });
    var navClose = document.getElementById('navClose');
    if(navClose) navClose.addEventListener('click', closeNav);
    overlay.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeNav); });
    overlay.addEventListener('keydown',function(e){ if(overlay.classList.contains('open')) trapFocus(e, overlay); });
  }

  /* -- Smooth scroll -- */
  function smoothScrollTo(target){
    if(!target) return;
    var headerH = hdr ? hdr.offsetHeight : 0;
    if(reduce){
      window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY - headerH - 12);
      return;
    }
    /* Reveal everything between here and the destination up front, so layout is
       stable before the animation begins. This prevents the scroll from chasing a
       target that moves as reveal transforms resolve mid-animation (the cause of
       the erratic toggling). */
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });

    var startY = window.scrollY;
    /* Capture the destination ONCE, after layout is stabilized. */
    var targetY = target.getBoundingClientRect().top + window.scrollY - headerH - 12;
    var maxY = Math.max(0, (document.documentElement.scrollHeight || document.body.scrollHeight) - window.innerHeight);
    if(targetY > maxY){ targetY = maxY; }
    if(Math.abs(targetY - startY) < 2){ return; }

    var start = null;
    var dur = 620;
    function ease(t){ return t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
    function step(ts){
      if(!start) start = ts;
      var prog = Math.min((ts - start) / dur, 1);
      window.scrollTo(0, startY + (targetY - startY) * ease(prog));
      if(prog < 1){ requestAnimationFrame(step); }
    }
    requestAnimationFrame(step);
  }
  document.querySelectorAll('[data-smooth-scroll]').forEach(function(link){
    link.addEventListener('click',function(e){
      var href = link.getAttribute('href');
      if(href && href.indexOf('#') > -1){
        var id = href.slice(href.indexOf('#') + 1);
        var target = document.getElementById(id);
        if(target){ e.preventDefault(); smoothScrollTo(target); }
      }
    });
  });

  /* -- Waitlist bottom sheet (focus trap + restore + inert) -- */
  var sheet      = document.getElementById('waitlist-sheet');
  var wsClose    = document.getElementById('wsClose');
  var wsBackdrop = document.getElementById('wsBackdrop');
  var sheetOpener = null;
  function openSheet(){
    if(!sheet) return;
    sheetOpener = document.activeElement;
    sheet.classList.add('open');
    sheet.setAttribute('aria-hidden','false');
    sheet.removeAttribute('inert');
    setInert([hdr, mainEl, footerEl], true);
    document.body.style.overflow = 'hidden';
    var input = sheet.querySelector('.ws-input');
    setTimeout(function(){ (input || wsClose) && (input || wsClose).focus(); }, 120);
  }
  function closeSheet(){
    if(!sheet || !sheet.classList.contains('open')) return;
    sheet.classList.remove('open');
    sheet.setAttribute('aria-hidden','true');
    sheet.setAttribute('inert','');
    setInert([hdr, mainEl, footerEl], false);
    document.body.style.overflow = '';
    if(sheetOpener && sheetOpener.focus) sheetOpener.focus();
  }
  document.querySelectorAll('[data-waitlist-trigger]').forEach(function(t){
    t.addEventListener('click',function(e){ e.preventDefault(); openSheet(); });
  });
  if(wsClose)    wsClose.addEventListener('click', closeSheet);
  if(wsBackdrop) wsBackdrop.addEventListener('click', closeSheet);
  if(sheet)      sheet.addEventListener('keydown',function(e){ if(sheet.classList.contains('open')) trapFocus(e, sheet); });

  /* -- If the waitlist sheet form posted successfully, keep the sheet open
     so the confirmation is visible. We do NOT auto-reopen if the CTA form
     at the bottom of the page posted; that form shows its own inline confirmation. */
  if(sheet){
    /* Shopify sets posted_successfully? on EVERY customer form on the page after any
       customer POST, so .ws-success existing is not proof the SHEET was submitted.
       Mark the real sheet submission in sessionStorage just before navigation and
       check it on the next load, so an inline-CTA signup no longer pops the sheet. */
    var sheetFormEl = document.getElementById('waitlist-sheet-form');
    if(sheetFormEl){
      sheetFormEl.addEventListener('submit', function(){
        try { sessionStorage.setItem('vlm_sheet_submit','1'); } catch(e){}
      });
    }
    var sheetSuccess = sheet.querySelector('.ws-success');
    var sheetWasSubmitted = false;
    try { sheetWasSubmitted = sessionStorage.getItem('vlm_sheet_submit') === '1'; } catch(e){}
    try { sessionStorage.removeItem('vlm_sheet_submit'); } catch(e){}
    if(sheetSuccess && sheetWasSubmitted){ openSheet(); }
  }

  /* -- Escape closes overlays -- */
  document.addEventListener('keydown',function(e){
    if(e.key === 'Escape'){ closeNav(); closeSheet(); }
  });

  /* -- Parallax (hero + split media) --
     Driven by a per-frame rAF loop, not scroll events. Mobile fires scroll events
     irregularly during momentum, so the old event-gated version lagged; sampling
     position every frame is what makes it smooth. The loop runs while scrolling and
     for a few frames after, then idles to spare the battery, and restarts on the
     next scroll. Reads (getBoundingClientRect) are batched before writes to avoid
     layout thrash. translate3d keeps each layer on the GPU. All transform, so it
     never reflows the page. Reduced-motion opts out entirely. -- */
  if(!reduce){
    var pTargets = [];
    var heroMedia = document.querySelector('.hero-media');
    if(heroMedia){ pTargets.push({ el: heroMedia, hero: true, y: null }); }
    document.querySelectorAll('.split .media.has-img').forEach(function(m){
      pTargets.push({ el: m, hero: false, y: null });
    });

    if(pTargets.length){
      var pRunning = false, pIdle = 0, pLastY = -1;

      function pFrame(){
        var sy = window.scrollY, vh = window.innerHeight, i, t;
        /* read phase */
        for(i = 0; i < pTargets.length; i++){
          t = pTargets[i];
          if(t.hero){
            t.y = (sy < vh * 1.3) ? sy * 0.32 : null;
          } else {
            var r = t.el.getBoundingClientRect();
            if(r.bottom > 0 && r.top < vh){
              var center = r.top + r.height / 2;
              var y = (vh / 2 - center) * 0.07;
              var max = r.height * 0.13;
              if(y > max){ y = max; } else if(y < -max){ y = -max; }
              t.y = y;
            } else { t.y = null; }
          }
        }
        /* write phase */
        for(i = 0; i < pTargets.length; i++){
          t = pTargets[i];
          if(t.y === null){ continue; }
          if(t.hero){ t.el.style.transform = 'translate3d(0,' + t.y.toFixed(1) + 'px,0)'; }
          else { t.el.style.setProperty('--py', t.y.toFixed(1) + 'px'); }
        }
        if(sy !== pLastY){ pLastY = sy; pIdle = 0; }
        else { pIdle++; }
        if(pIdle < 10){ requestAnimationFrame(pFrame); }
        else { pRunning = false; }
      }

      function pKick(){ if(!pRunning){ pRunning = true; pIdle = 0; pLastY = -1; requestAnimationFrame(pFrame); } }

      pKick();
      window.addEventListener('scroll', pKick, { passive: true });
      window.addEventListener('resize', pKick, { passive: true });
      window.addEventListener('orientationchange', pKick, { passive: true });
    }
  }

})();
